import { Box, styled, Typography } from '@mui/material';
import { ComponentProps } from 'react';

export const StyledStack = styled(Box)({
  display: 'inline-flex',
});

export const StyledDistroDark = styled(Typography)(({ theme }) => ({
  fontWeight: 400,
  fontSize: 16,
  color: theme.palette.grey[900],
}));

export const StyledDistroLight = styled(StyledDistroDark)(({ theme }) => ({
  color: theme.palette.grey[50],
}));

export const StyledPlusText = styled(Typography)(({ theme }) => ({
  fontWeight: 900,
  fontSize: 16,
  color: theme.palette.secondary.dark,
}));

export const StyledPlusTextLight = styled(StyledPlusText)(({ theme }) => ({
  color: theme.palette.secondary.main,
}));

export const StyledPlusSignBase = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  fontWeight: 900,
  color: theme.palette.secondary.dark,
}));

export const StyledPlusSign = (
  props: ComponentProps<typeof StyledPlusSignBase>
) => <StyledPlusSignBase variant="caption" {...props} />;

export const StyledPlusSignLightBase = styled(StyledPlusSign)(({ theme }) => ({
  color: theme.palette.secondary.main,
}));

export const StyledPlusSignLight = (
  props: ComponentProps<typeof StyledPlusSignLightBase>
) => <StyledPlusSignLightBase variant="caption" {...props} />;
